import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-voltar',
  templateUrl: './voltar.component.html',
  styleUrls: ['./voltar.component.scss']
})
export class VoltarComponent implements OnInit {
  @Input() route: string = '';

  constructor(
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {}

  voltar() {
    // this.router.navigate([this.route]);
    this.location.back();
  }
}
